import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchWithCsrf } from "@/lib/api";
import { useNavigate } from "react-router";
import { CURRENT_USER_QUERY_KEY } from "./useCurrentUser";
import type { SignupData, User } from "@/types/auth";
import type { ApiSuccess, ApiError } from "@/types/api";

interface SignupResponse {
  user: User;
}

export function useSignup() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<ApiSuccess<SignupResponse>, ApiError, SignupData>({
    mutationFn: async (data) => {
      return fetchWithCsrf("/api/registration", {
        method: "POST",
        body: JSON.stringify({ user: data }),
      });
    },
    onSuccess: (response) => {
      queryClient.setQueryData(CURRENT_USER_QUERY_KEY, response.data.user);
      navigate("/");
    },
  });
}
